'use server'

import { cookies } from 'next/headers'
import {
    deleteCartItem,
    updateQtyItem,
    clearCart,
    addCartItem,
    getCartItems,
} from '../cart'

export async function actionAddCartItem(variant_id: string, quantity: number) {
    const cookieStore = await cookies()

    const basket_id = cookieStore.get('basket_id')?.value ?? null
    const response = await addCartItem(variant_id, quantity, basket_id)

    console.log(basket_id, response, 'СЕРВЕРНЫЙ АКШИОН КОРЗЫ')
    if (response?.basket_id) {
        cookieStore.set('basket_id', response.basket_id, {
            httpOnly: true,
            path: '/',
            maxAge: 60 * 60 * 24 * 7, // 7 days
        })
    }
    return response
}

export async function actionGetCartItems() {
    const cookieStore = await cookies()
    const basket_id = cookieStore.get('basket_id')?.value ?? null

    if (!basket_id) {
        return {
            basket_id: null,
            items: [],
            empty: true,
        }
    }

    const data = await getCartItems(basket_id)

    return {
        basket_id,
        ...data,
    }
}

export async function actionDeleteItem(item_id: string) {
    const cookieStore = await cookies()
    const basket_id = cookieStore.get('basket_id')?.value

    if (!basket_id) return { error: 'basket_id отсутсвует' }
    return await deleteCartItem(item_id)
}

export async function actionChangeQty(item_id: string, newQty: number) {
    const cookieStore = await cookies()
    const basket_id = cookieStore.get('basket_id')?.value
    if (!basket_id) return { error: 'basket_id отсутствует' }

    return await updateQtyItem(basket_id, item_id, newQty)
}

export async function actionClearCart() {
    const cookieStore = await cookies()
    const basket_id = cookieStore.get('basket_id')?.value
    if (!basket_id) return { error: 'basket_id отсутствует' }

    return await clearCart(basket_id)
}
